import { useCallback, useEffect, useState } from 'react';
export const useScrollableCheck = (ref) => {
    const [isScrollable, setIsScrollable] = useState(false);
    const checkIfScrollable = useCallback(() => {
        const element = ref.current;
        if (element) {
            const hasVerticalScroll = element.scrollHeight > element.clientHeight;
            setIsScrollable(hasVerticalScroll);
        }
    }, [ref]);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const resizeObserver = new ResizeObserver(checkIfScrollable);
        resizeObserver.observe(element);
        return () => {
            resizeObserver.disconnect();
        };
    }, [checkIfScrollable, ref]);
    return isScrollable;
};
//# sourceMappingURL=useScrollableCheck.js.map